export default __webpack_public_path__ + "static/bullet-801c06eae52e96797db7250b0fb48c6a.png";